// Importing the Rellax library
import Rellax from 'rellax';

// Using the Rellax library to make all divs with a class of 'rellax' parallax
window.onload = function () {
    let rellax = new Rellax('.image-with-background .rellax', {
        speed: 5,
        center: true,
    });
};